(function () {
  'use strict';

  var FIELD_SELECTOR = '.membership-field';
  var VISIBILITY_ATTR = 'data-visibility';
  var HIDDEN_CLASS = 'membership-field--hidden';
  var ERROR_CLASS = 'membership-field--error';

  /**
   * Parse a visibility string "fieldId:value" into its parts.
   * Returns { id: string, value: string } or null if invalid.
   */
  function parseVisibility(str) {
    if (!str) return null;
    var colonIndex = str.indexOf(':');
    if (colonIndex === -1) return null;
    return {
      id: str.substring(0, colonIndex).trim(),
      value: str.substring(colonIndex + 1).trim()
    };
  }

  /**
   * Get the current value of a membership field by its wrapper element ID.
   * Supports radio groups, text inputs, and select elements.
   */
  function getFieldValue(fieldId) {
    var wrapper = document.getElementById(fieldId);
    if (!wrapper) return '';

    // Radio: find checked input
    var checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio.value;

    // Select
    var select = wrapper.querySelector('select');
    if (select) return select.value;

    // Text input
    var input = wrapper.querySelector('input[type="text"], input[type="email"]');
    if (input) return input.value;

    return '';
  }

  /**
   * Clear the value of all inputs within a field wrapper.
   * Prevents hidden fields from submitting stale data.
   */
  function clearFieldInputs(wrapper) {
    var radios = wrapper.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = false;
    }

    var inputs = wrapper.querySelectorAll('input[type="text"], input[type="email"]');
    for (var j = 0; j < inputs.length; j++) {
      inputs[j].value = '';
    }

    var selects = wrapper.querySelectorAll('select');
    for (var k = 0; k < selects.length; k++) {
      selects[k].selectedIndex = 0;
    }

    // Clear any error state
    wrapper.classList.remove(ERROR_CLASS);
  }

  /**
   * Evaluate visibility for all fields with a data-visibility attribute.
   */
  function evaluateVisibility() {
    var fields = document.querySelectorAll('[' + VISIBILITY_ATTR + ']');

    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var rule = parseVisibility(field.getAttribute(VISIBILITY_ATTR));
      if (!rule) continue;

      var currentValue = getFieldValue(rule.id);
      var shouldShow = currentValue === rule.value;

      if (shouldShow) {
        field.classList.remove(HIDDEN_CLASS);
      } else {
        field.classList.add(HIDDEN_CLASS);
        clearFieldInputs(field);
      }
    }
  }

  /**
   * Validate required fields that are currently visible.
   * Returns true if all valid, false otherwise.
   */
  function validateRequired() {
    var allValid = true;
    var fields = document.querySelectorAll(FIELD_SELECTOR);

    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];

      // Skip hidden fields
      if (field.classList.contains(HIDDEN_CLASS)) {
        field.classList.remove(ERROR_CLASS);
        continue;
      }

      // Check for required inputs
      var requiredInputs = field.querySelectorAll('[data-required="true"]');
      if (requiredInputs.length === 0) continue;

      var hasValue = false;
      var firstInput = requiredInputs[0];

      if (firstInput.type === 'radio') {
        // For radios, check if any in the group is checked
        var radios = field.querySelectorAll('input[type="radio"]');
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].checked) {
            hasValue = true;
            break;
          }
        }
      } else if (firstInput.tagName === 'SELECT') {
        hasValue = firstInput.value !== '';
      } else {
        hasValue = firstInput.value.trim() !== '';
      }

      if (hasValue) {
        field.classList.remove(ERROR_CLASS);
      } else {
        field.classList.add(ERROR_CLASS);
        allValid = false;
      }
    }

    return allValid;
  }

  /**
   * Disable hidden field inputs so they don't submit with the form.
   * Re-enable visible field inputs.
   */
  function syncDisabledState() {
    var fields = document.querySelectorAll(FIELD_SELECTOR);

    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var isHidden = field.classList.contains(HIDDEN_CLASS);
      var inputs = field.querySelectorAll('input, select, textarea');

      for (var j = 0; j < inputs.length; j++) {
        inputs[j].disabled = isHidden;
      }
    }
  }

  /**
   * Initialise: set up event listeners and run initial visibility pass.
   */
  function init() {
    // Run initial visibility evaluation
    evaluateVisibility();
    syncDisabledState();

    // Listen for changes on all membership field inputs
    document.addEventListener('change', function (e) {
      var target = e.target;
      var membershipField = target.closest(FIELD_SELECTOR);
      if (!membershipField) return;

      evaluateVisibility();
      syncDisabledState();

      // Clear error on the changed field
      membershipField.classList.remove(ERROR_CLASS);
    });

    // Listen for input events on text fields (clear error on typing)
    document.addEventListener('input', function (e) {
      var target = e.target;
      var membershipField = target.closest(FIELD_SELECTOR);
      if (!membershipField) return;

      membershipField.classList.remove(ERROR_CLASS);
    });

    // Intercept form submission for required field validation
    var productForm = document.querySelector('form.product-form, form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        if (!validateRequired()) {
          e.preventDefault();
          e.stopPropagation();

          // Scroll to first error
          var firstError = document.querySelector('.' + ERROR_CLASS);
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
